/* eslint-disable max-len */
import Immutable from 'seamless-immutable';
import createReducer from '../helpers/createReducer';
import {
  config as state
} from '../store';

export default createReducer(state, {
  SET_LANGS: (state, { data }) => Immutable({ ...state, langs: data }),
  SET_TITLE: (state, { data }) => Immutable({ ...state, title: data }),
  SET_SCHEDULE: (state, { data }) => Immutable({ ...state, schedule: data }),
  SET_PAGE_TITLE: (state, { data }) => Immutable({ ...state, pageTitle: data }),
  SET_COLLECTION: (state, { data }) => Immutable({ ...state, collection: data }),
  SET_DISTRICT_ID: (state, { data }) => Immutable({ ...state, districtId: data }),
  SET_LOCALITY_ID: (state, { data }) => Immutable({ ...state, localityId: data }),
  SET_COUNTRY_CD: (state, { data }) => Immutable({ ...state, countryCode: data }),
  SET_IS_ACTIVE: (state, { data }) => Immutable({ ...state, isActive: data }),
  SET_DEFAULT_LANG: (state, { data }) => Immutable({ ...state, defaultLang: data }),
  SET_SELECTED_LANG: (state, { data }) => Immutable({ ...state, selectedLang: data }),
  SET_DISTRICT_LABEL: (state, { data }) => Immutable({ ...state, districtLabel: data }),
  SET_SEARCH_AT_FIRST: (state, { data }) => Immutable({ ...state, searchAtFirst: data }),
  SET_TEMPLATE_COLOUR: (state, { data }) => Immutable({ ...state, templateColour: data }),
  SET_REMINDER_OPTION: (state, { data }) => Immutable({ ...state, reminderOption: data }),
  SET_IS_MULTI_DISTRICT: (state, { data }) => Immutable({ ...state, isMultiDistrict: data }),
  SET_WEBAPP_CONFIGURATION: (state, { data }) => Immutable({ ...state, webappConfig: data }),
  SET_IS_PROMPT_MESSAGE_OPEN: (state, { data }) => Immutable({ ...state, isPromptMessageOpen: data }),
  SET_SHOULD_SEE_DISTRICT_SELECTOR: (state, { data }) => Immutable({ ...state, shouldSeeDistrictSelector: data }),
});
